import { Box, Typography, useTheme } from '@mui/material'
import React, { Fragment, useState } from 'react'
import { Tooltip } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'
import { useTranslation } from 'react-i18next'
import ReactHtmlParser from 'react-html-parser'
import DomPurify from 'dompurify'

const InfoTooltip = ({
    message = '',
    properties = [],
    style = {},
    IconComponent,
    iconHoverColor,
    disableInteractive = false,
}) => {
    const theme = useTheme()
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = useState(false)
    const infoMessage = () => {
        if (message) {
            return (
                <Box padding="1rem">
                    <Typography
                        style={{
                            fontSize: '1.4rem',
                            fontWeight: '600',
                        }}
                    >
                        {ReactHtmlParser(
                            DomPurify.sanitize(message, {
                                ADD_ATTR: ['target'],
                            }),
                        )}
                    </Typography>
                </Box>
            )
        }

        return (
            <Box
                padding="1rem"
                style={{
                    minWidth: '40rem',
                }}
            >
                {properties.map((prop, index) => (
                    <Box
                        key={`${prop.key}-${index}`}
                        display="flex"
                        style={{
                            gap: '1rem',
                            marginTop: index > 0 ? '1.5rem' : 0,
                        }}
                    >
                        <Typography
                            variant="label"
                            style={{
                                fontSize: '1.2rem',
                                textTransform: 'uppercase',
                                color: '#9b9b9b',
                                fontWeight: '600',
                                maxWidth: '11rem',
                                width: '100%',
                                marginTop: '.1rem',
                            }}
                        >
                            {t(prop.key)}
                        </Typography>
                        <Typography
                            style={{
                                fontSize: '1.4rem',
                                fontWeight: '600',
                            }}
                        >
                            {prop.value || '-'}
                        </Typography>
                    </Box>
                ))}
            </Box>
        )
    }

    return (
        <>
            {(message || properties.length > 0) && (
                <Box sx={{ ml: '0.8rem', ...style }}>
                    <Tooltip
                        disableInteractive={disableInteractive}
                        title={infoMessage()}
                        color={theme?.palette?.common?.white}
                        fontColor={theme?.palette?.common?.black}
                        tooltipStyles={{
                            maxWidth: '65rem',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.1)',
                            width: '100%',
                        }}
                        arrow={true}
                        onOpen={() => setIsOpen(true)}
                        onClose={() => setIsOpen(false)}
                    >
                        <Box
                            sx={{
                                height: '1.6rem',
                                '& path': {
                                    fill: isOpen && iconHoverColor,
                                },
                                '&:hover': {
                                    '& path': {
                                        fill: iconHoverColor,
                                    },
                                },
                            }}
                        >
                            {IconComponent}
                        </Box>
                    </Tooltip>
                </Box>
            )}
        </>
    )
}

export default InfoTooltip
